import { categoryService } from '../../services'

// initial state
const state = () => ({
  categories: [],
  category: null,
  template: null
})

// actions
const actions = {
  getCategories({ commit, rootState }, eventId) {
    if (!eventId) {
      eventId = rootState.event?.activeEvent?.id
    }
    categoryService.getCategories(eventId).then(
      (categories) => {
        commit('getCategoriesSuccess', categories)
      },
      (error) => {
        commit('getCategoriesFailure', error)
      }
    )
  },
  getCategoriesTemplate({ commit }, eventId) {
    return categoryService.getCategoriesTemplate(eventId).then(
      (categories) => {
        commit('getCategoriesSuccess', categories)
        return JSON.parse(JSON.stringify(categories))
      },
      (error) => {
        commit('getCategoriesFailure', error)
      }
    )
  },
  getCategory({ commit }, categoryId) {
    categoryService.getCategory(categoryId).then(
      (category) => {
        commit('categorySuccess', category)
      },
      (error) => {
        commit('categoryFailure', error)
      }
    )
  },
  createCategory({ commit }, categoryData) {
    categoryService.createCategory(categoryData).then(
      (category) => {
        commit('categorySuccess', category)
      },
      (error) => {
        commit('categoryFailure', error)
      }
    )
  },
  updateCategory({ commit, dispatch }, { categoryId, categoryData }) {
    categoryService.updateCategory(categoryId, categoryData).then(
      (category) => {
        commit('categorySuccess', category)
        dispatch('getCategories')
      },
      (error) => {
        commit('categoryFailure', error)
      }
    )
  },
  deleteCategory({ commit, dispatch }, categoryId) {
    categoryService.deleteCategory(categoryId).then(
      (category) => {
        commit('categoryDelete', category.id)
        dispatch('getCategories')
      },
      (error) => {
        commit('categoryFailure', error)
      }
    )
  },
  downloadTemplateFile({ commit }, hasType) {
    categoryService.downloadTemplate(hasType).then(
      (template) => {
        commit('downloadSuccess', template)
      },
      (error) => {
        commit('downloadFailure', error)
      }
    )
  },
  importCategories({ commit }, categoriesData) {
    categoryService.importCategories(categoriesData).then(
      (categories) => {
        commit('getCategoriesSuccess', categories)
      },
      (error) => {
        commit('categoryImportFailure', error)
      }
    )
  }
}

// mutations
const mutations = {
  getCategoriesSuccess(state, categories) {
    state.categories = categories
  },
  categorySuccess(state, category) {
    state.category = category
  },
  getCategoriesFailure(state, error) {
    console.log(state, error)
  },
  categoryFailure(state, error) {
    console.log(state, error)
  },
  categoryDelete(state, categoryId) {
    let index = state.categories.findIndex(
      (category) => category.id == categoryId
    )
    state.categories.splice(index, 1)
  },
  downloadSuccess(state, template) {
    state.template = template
  },
  downloadFailure(state, error) {
    state.template = null
    console.log(error)
  },
  categoryImportFailure(state, error) {
    state.categories = []
    console.log(error)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
